import { clamp } from ".";

export interface IColor {
    r: number;
    g: number;
    b: number;
}

export default class Color {
    r: number;
    g: number;
    b: number;

    static lerp(a: Color|IColor|[number, number, number], b: Color|IColor|[number, number, number], t: number) {
        let r1,r2,g1,g2,b1,b2;

        if (Array.isArray(a)) {
            [r1,g1,b1] = a;
        } else {
            r1 = a.r;
            g1 = a.g;
            b1 = a.b;
        }

        if (Array.isArray(b)) {
            [r2,g2,b2] = b;
        } else {
            r2 = b.r;
            g2 = b.g;
            b2 = b.b;
        }

        return new Color(
            (r2 - r1) * t + r1,
            (g2 - g1) * t + g1,
            (b2 - b1) * t + b1
        );
    }

    static fromArray(arr: [number, number, number]) {
        return new Color(arr[0], arr[1], arr[2]);
    }

    static fromHex(hex: string) {
        if (hex.startsWith("#")) hex = hex.substring(1);

        const values = hex.match(/[\da-f]{2}/ig)?.map(v => parseInt(v, 16));

        if (!values) return new Color(0, 0, 0);

        const [r,g,b] = values;

        return new Color(r || 0, g || 0, b || 0);
    }

    constructor(r: number, g: number, b: number) {
        this.r = Math.floor(clamp(r, 0, 255));
        this.g = Math.floor(clamp(g, 0, 255));
        this.b = Math.floor(clamp(b, 0, 255));
    }

    toArray(): [number, number, number] {
        return [this.r, this.g, this.b];
    }

    toHex() {
        return "#" + [this.r, this.g, this.b].map(v => v.toString(16).padStart(2, '0')).join("");
    }

    toHexWithAlpha(alpha: number) {
        const alphaComp = Math.floor(alpha * 255).toString(16).padStart(2, '0');
        return this.toHex() + alphaComp;
    }

    toRgbString() {
        return `rgb(${this.r}, ${this.g}, ${this.b})`;
    }

    toRgbaString(alpha: number) {
        return `rgb(${this.r}, ${this.g}, ${this.b}, ${alpha})`;
    }

    equals(other: Color) {
        return this.r === other.r &&  this.g === other.g && this.b === other.b;
    }
}